import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { isAdvanceModeVisible } from 'selectors/user';
import { clickAdvanceMode, setActionType } from 'actions/reports';
import { reportDataSelectors } from 'selectors/reports';
import Icon from './foundations/Icon';
import { CheckableField } from './widgets';
import css from './AdvancedModeButton.css';

const AdvancedModeButton = ({ reportType }) => {
    const dispatch = useDispatch();

    const reportState = useSelector(state => reportDataSelectors[reportType](state));

    if (!isAdvanceModeVisible(reportType) || !reportState.selectedSources?.length || !reportState.selectedApps?.length)
        return null;

    const checked = !!reportState.isAdvanceMode;
    const disabled = !!reportState.disableReportState;

    const onClick = () => dispatch(setActionType(clickAdvanceMode(), reportType));

    return (
        <CheckableField
            icon={<Icon name="settings-search" />}
            persistentIcon
            fieldClassName={css.container}
            field={{
                display_name: 'STATIC.PAGES.REPORTS.ADVANCE_MODE_BUTTON',
                shouldShowDisabled: true,
                checked,
                disabled,
            }}
            onClick={onClick}
        />
    );
};

AdvancedModeButton.propTypes = {
    reportType: PropTypes.string.isRequired,
};

export default AdvancedModeButton;
